import req from "../../../services/psikotest/request";

class AssessmentCfitSubtest {
  async create(data: TPSAssessmentCfitSubtest) {
    try {
      const res = await req.post("/api/psikotest_system/assessment_cfit_subtest/", data);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  async update(data: TPSAssessmentCfitSubtest) {
    try {
      const res = await req.put("/api/psikotest_system/assessment_cfit_subtest/" + data.id, data);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  async delete(data: TPSAssessmentCfitSubtest) {
    try {
      const res = await req.delete("/api/psikotest_system/assessment_cfit_subtest/", { data });
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  async participant_session(data: TPSAssessmentCfitSubtest) {
    try {
      const res = await req.get("/api/psikotest_system/assessment_cfit_subtest/" + data.id + "/participant_session");
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
}

export default AssessmentCfitSubtest;
